var cssClassIdx = 0;
export function getClassId() {
    return cssClassIdx++;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/zrender/lib/svg/cssClassId.js
// module id = null
// module chunks = 